// ─────────────────────────────────────────────────────────────────────────────
// auth/accountName.js — the account's name (backend PLAN.md)
//
// Asked at sign-up, or once before the Studio opens for accounts without one;
// changed later in Settings → Security. The server cleans and checks it; these
// helpers only save it and keep the passkeys' label in step (decision D2).
// ─────────────────────────────────────────────────────────────────────────────

import axios from "axios";
import { sendSignal } from "@simplewebauthn/browser";
import { authHeader } from "../authClient";
import { RP_ID } from "./passkeys";

export const NAME_MIN = 2;
export const NAME_MAX = 40;

/** True when the typed name has enough visible characters to send. */
export const nameLooksValid = (value) => String(value || "").replace(/\s+/g, " ").trim().length >= NAME_MIN;

/**
 * Saves the name. Then asks the browser to relabel this account's passkeys in
 * the password manager (Chrome does; others ignore it, harmlessly).
 * Resolves the name as the server stored it.
 */
export async function saveAccountName(name) {
  const { data } = await axios.patch("/api/me/name", { name }, { headers: authHeader() });
  if (data?.passkeyUserId) {
    sendSignal({
      signalName: "currentUserDetails", rpID: RP_ID, userID: data.passkeyUserId,
      userName: data.displayName, userDisplayName: data.displayName
    }).catch(() => { /* not supported here */ });
  }
  return data.displayName;
}

/** The account's name and whether the Studio must ask for one first. */
export async function loadAccountName() {
  const { data } = await axios.get("/api/me", { headers: authHeader(), skipReauth: true });
  return { displayName: data?.displayName || "", needsName: !!data?.needsName };
}
